import React, { useContext } from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Navigation from "../components/navigation"
import useRedirectToLang from "../hooks/useRedirectToLang"
import { ViewportContext } from "../contexts/viewport-context"

const NotFoundZhPage = () => {
  const content = require("../data/not-found.json")["cn"]
  useRedirectToLang("/cn/404")
  const dimensions = useContext(ViewportContext)

  return (
    <>
      <SEO title={`404: ${content[0]}`} lang="zh" />
      <Layout width={dimensions[0]}>
        <div className="not-found">
          <h1>{content[0]}</h1>
          <p>{content[1]}</p>
        </div>
      </Layout>
      <Navigation path="/cn/404" lang="cn" width={dimensions[0]} />
    </>
  )
}

export default NotFoundZhPage
